import $ from 'jquery';
import { WEEKDAYS } from './scheduleConfig';
import {dateKey, slotKey, parseKey, formatDay, isDatePassed} from './dateUtils';
import { buildRow } from './scheduleRowBuilder';

const DAY_CONTAINER = '#myScheduleDay';

/**
 * Запись на 1 час занимает 2 слота с одинаковым ID — показываем только последний слот
 * (как и в старой логике).
 */
function collapseLongAppointments(slots, doctorKey) {
    return slots.filter((slot, i) => {
        const id = slot[doctorKey].ID;
        const next = slots[i + 1];
        return !(id !== null && next && next[doctorKey].ID === id);
    });
}

const dayTitle = (key, isToday) => {
    const date = parseKey(key);
    return `<div class="myScheduleBox__title"><strong>${WEEKDAYS[date.getDay()]},  ${formatDay(date)}</strong>${isToday ? '  <span class="badge bg-success">Сегодня</span>' : ''}</div>`;
};

const dayTable = (key) => `
        <table class="table table-bordered myScheduleTable">
            <thead>
                <tr>
                    <th class="myScheduleTable__title myScheduleTable__title-time">время</th>
                    <th class="myScheduleTable__title myScheduleTable__title-fio">фамилия <br>имя</th>
                    <th class="myScheduleTable__title myScheduleTable__title-birthday">дата <br>рождения</th>
                    <th class="myScheduleTable__title myScheduleTable__title-phone">телефон</th>
                    <th class="myScheduleTable__title myScheduleTable__title-order">под-<br>твердить</th>
                    <th class="myScheduleTable__title myScheduleTable__title-reception">прием</th>
                    <th class="myScheduleTable__title myScheduleTable__title-diagnostic">вид <br>диагностики</th>
                    <th class="myScheduleTable__title myScheduleTable__title-comment">комментарий</th>
                    <th class="myScheduleTable__title myScheduleTable__title-who-wrote">анкета</th>
                    <th class="myScheduleTable__title myScheduleTable__title-where-come-from">откуда<br> пришел</th>
                </tr>
            </thead>
            <tbody id="myScheduleTbody-${key}"></tbody>
        </table>`;

const dayBox = function (key, isToday, hasSlots,) {
    let dayClasses = 'myScheduleBox__item'
    if (!isDatePassed(key)) {
        dayClasses += ' active'
    }

    return `
    <div class="${dayClasses}" id="myScheduleBox-${key}">
        ${dayTitle(key, isToday)}
        ${hasSlots ? dayTable(key) : '<div class="alert alert-secondary m-2">На этот день расписания нет</div>'}
    </div>`;
};

export function clearSchedule() {
    $(DAY_CONTAINER).empty();
}

export function renderError(message = 'Не удалось загрузить расписание. Попробуйте ещё раз.') {
    $(DAY_CONTAINER).html(`<div class="alert alert-danger">${message}</div>`);
}

/**
 * ДОБАВЛЯЕТ день в конец списка (очистка — отдельно через clearSchedule).
 * rows — слоты от сервера, key — 'YYYY-MM-DD', ctx — см. scheduleRowBuilder
 */
export function renderDay(rows, ctx, key) {
    const doctorKey = 'd' + ctx.staffId;
    const slots = (rows || []).filter((r) => slotKey(r.t) === key);

    $(DAY_CONTAINER).append(dayBox(key, key === dateKey(new Date()), slots.length > 0));
    if (slots.length === 0) return;

    const $tbody = $('#myScheduleTbody-' + key);
    collapseLongAppointments(slots, doctorKey).forEach((slot) => {
        const info = slot[doctorKey];
        const unitId = new Date(slot.t).getTime() / 1000;
        $tbody.append(buildRow(slot.t, info, { ...ctx, unitId }));
        // выбираем ранее сохранённую услугу
        $(`#orderServiceList-${unitId} option[value="${info.DiagnosticType}"]`).attr('selected', 'selected');
    });
}

export function groupRowsByDay(rows) {
    const result = {};

    (rows || []).forEach((row) => {
        const key = slotKey(row.t);

        if (!result[key]) {
            result[key] = [];
        }

        result[key].push(row);
    });

    return result;
}
